
import zhCN from "ant-design-vue/es/locale/zh_CN";
import { defineComponent, ref, watch, watchEffect } from "vue";
import { Modal } from "ant-design-vue";
import { useStore } from "vuex";
import { lFrame } from "./component/";
import { api } from "./api/data";

export default defineComponent({
  components: {
    lFrame,
  },
  setup() {
    const store = useStore();
    const keepAlive = ref<Record<any, any>>(store.getters.assnUserPages);
    const updateKeepAlive = () => {
      keepAlive.value = store.getters.assnUserPages;
    };
    watch(
      () => store.getters.assnUserPages,
      () => {
        updateKeepAlive();
      }
    );
    // get menu start
    const getMenu = async () => {
      const menus = await api("menu");
      if (menus.status === false) {
        Modal.error({
          centered: true,
          content: () => menus.data,
        });
      } else {
        store.commit("setDatas", ["assnUserMenus", menus.data]);
      }
    };
    watchEffect(() => {
      if (store.getters.assnUserToken) {
        getMenu();
      }
    });
    // get menu end
    return {
      locale: zhCN,
      keepAlive,
    };
  },
});
